import {PlatformAPIHttpClient} from "./platform-api-http-client";

export class LoginHttpClient extends PlatformAPIHttpClient {
    public authenticate = (username: string, password: string) => this.instance.post('/auth', {
        'email': username,
        'password': password
    });

    public logout = () => this.instance.delete('/logout');
}